import React from 'react';
import { useParams } from 'react-router-dom';
import "./ProjectDetail.css";
import ProjectDetailMap from './ProjectDetailMap';
import { applicationProgressConfig, categoryConfigs } from '../UkMapLeaflet/UkMapSettings';

function ProjectDetail({ data }) {
  const { projectRef } = useParams();
  const project = data.find(row => row.ProjectReference === projectRef);

  if (!project) {
    return <p>No project found for reference: {projectRef}</p>;
  }

  var { ProjectName, ImageURL, Description } = project;
  const clr = applicationProgressConfig[project.Decision].color;
  var decision = project.Decision;
  if (decision === "In Progress") decision = 'In Progress';
  
  ImageURL = ImageURL.replace(/\s+/g, '');

  const isNonNSIP = 
    project.NonNSIP === true ||
    project.NonNSIP === 'TRUE' ||
    project.NonNSIP === 'True' ||
    project.NonNSIP === 'true';

  return (
    <div className="project-page">
      {/* Hero Image */}
      <div 
          className="project-page__hero"
          style={{
            backgroundImage: `url(${ImageURL || '/images/windfarms.jpg'})`,
          }}
        >
        <h1>{ProjectName}</h1>
        </div>
        <ProjectDetailMap
          project={project}
          iconMarker={categoryConfigs[project.ApplicationCategory].icon}
          color={clr}
        />

      {/* Main Content */}

      <div className="project-staus" style={{backgroundColor: clr}}>
          <p>{decision}</p>
        </div>
      

      <div className="project-kpis-wrapper">
          <div className="project-kpis">
            <div className="kpi-item">
              <span className="kpi-label">Applicant</span>
              <span className="kpi-value">{project['ApplicantName']}</span>
            </div>
            <div className="kpi-item">
              <span className="kpi-label">Category</span>
              <span className="kpi-value">{project.ApplicationCategory}</span>
            </div>
            <div className="kpi-item">
              <span className="kpi-label">Region</span>
              <span className="kpi-value">{project.Region}</span>
            </div>
          </div>
        </div>

      <div className="project-page__content">
        {isNonNSIP && (
            <div className="nonsip-banner">
              <strong>This project is classified as a major project</strong> rather than a Nationally Significant Infrastructure Project (NSIP). 
              While it doesn't follow the specialised NSIP planning process, 
              we include it in our tracker due to its significant scale and potential impact on 
              local communities and infrastructure.
            </div>
          )}


        <p className="project-page__description">{Description}</p>
      </div>
    </div>
  );
}

export default ProjectDetail;
